// extracted by mini-css-extract-plugin
export default {"container":"TD-z","dimension":"UD-z","dimensionLabels":"VD-z"};